var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('work',[_c('work-project',_vm._b({key:_vm.project.id},'work-project',_vm.project,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }